export default __webpack_public_path__ + "1ae1d25667b2dc1ab6b2d5bfcb3e35c2.png";